export const iconFontAwesomeMapsFireExtinguisher = (
	<i className="fa-solid fa-fire-extinguisher"></i>
);
